import { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Sidebar.css';
import Image from '../general/Image';
import { ROUTES } from '../../routes/RouteList';
import { discoverUs } from '../../constants/base';
import Button from '../general/Button';
import { useSelector } from 'react-redux';

const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const { tech : {technologies}, spec : {specializationList} } = useSelector((state) => state.common);
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  
  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest('.sidebar')) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  const menuItems = useMemo(() => {
    return [
      {
        title: 'Login',
        path: ROUTES.LOGIN_REGISTER,
        onClick: () => {},
      },
      {
        title: 'Discover Us',
        submenu: discoverUs.map((item) => ({
          title: item.title,
          path: item.URL
        })),
        isOpen: undefined,
        onClick: () => {},
        permanentlyOpen: true
      },
      {
        title: 'Hire by role',
        submenu: specializationList.map((item) => ({
          title: item.name,
          path: `/hire/role/${item.slug}`
        })),
        isOpen: isServicesOpen,
        onClick: () => setIsServicesOpen((open) => !open),
      },
      {
        title: 'Hire by skill',
        submenu: technologies.map((item) => ({
          title: item.name,
          path: `/hire/skill/${item.slug}`
        })),
        isOpen: isServicesOpen,
        onClick: () => setIsServicesOpen((open) => !open),
      },
      {
        title: "Hire Instantly",
        isOpen: undefined,
        path: ROUTES.START_HIRING,
        onClick: () => {},
      },
      {
        title : "Join as Developer",
        isOpen: undefined,
        path: ROUTES.FIND_JOBS,
        onClick: () => {},
      }
    ];
  }, [technologies, isServicesOpen])

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  return (
    <>
      {/* Overlay */}
      <div
        className={`overlay ${isOpen ? 'show' : ''}`}
        onClick={onClose}
      />

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? 'open' : ''}`}>
        <div className="p-6">
          <div className="mb-8">
            <Image src={'/images/logo.png'} />
          </div>

          <nav>
            <ul className="space-y-4">
              {menuItems.map((item) => (
                <li key={item.title}>
                  {item.submenu ? (
                    <>
                      <Button
                        onClick={item.onClick}
                        className="w-full text-left flex py-2 px-4 rounded-lg hover:bg-gray-800 transition-colors duration-200 items-center justify-between"
                      >
                        {item.title}
                        <span
                          className={`transition-transform duration-300 ${item.isOpen ? 'rotate-90' : 'rotate-0'}`}
                          style={{ display: 'inline-flex', alignItems: 'center' }}
                        >
                          {/* Chevron Right SVG */}
                          <svg width="16" height="16" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7 5L12 10L7 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </span>
                      </Button>
                      <div
                        className={`overflow-y-auto transition-all duration-300 ${item.isOpen || item.permanentlyOpen ? 'max-h-[250px] opacity-100' : 'max-h-0 opacity-0'}`}
                        style={{ transitionProperty: 'max-height, opacity' }}
                      >
                        <ul className="pl-6 mt-2 space-y-2">
                          {item.submenu.map((sub) => (
                            <li key={sub.title}>
                              <button
                                onClick={() => handleNavigation(sub.path)}
                                className="w-full text-left block py-2 px-4 rounded-lg hover:bg-gray-700 transition-colors duration-200 text-sm"
                              >
                                {sub.title}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </>
                  ) : (
                    <button
                      onClick={() => handleNavigation(item.path)}
                      className="w-full text-left block py-2 px-4 rounded-lg hover:bg-gray-800 transition-colors duration-200"
                    >
                      {item.title}
                    </button>
                  )}
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
